import * as React from 'react';

import './styles/Swatch.scss';

export type SwatchColors = 'pool' | 'globe' | 'mascot' | 'ballpoint' | 'pennant';

type Props = {
  color: SwatchColors;
};

function Swatch(props: Props) {
  return <div className={`Swatch Swatch--${props.color}`} aria-hidden />;
}

export default Swatch;
